import { useFormContext } from "react-hook-form";
import React from "react";
import Hint from "@/shared/ui/hint";
import { TAttributesRows } from "@/widgets/create-order-form/model/types";
import {
  NewOrderAttributes,
  NewOrderScenario,
  TNewOrderForm,
} from "@/entities/new-order";
import { Checkbox } from "@/shared/ui/checkbox";
import styles from "./attributes-block.module.scss";

export const DistributeAttribute = ({
  attributesList,
  handleCheckboxChange,
}: TAttributesRows) => {
  const { watch } = useFormContext<TNewOrderForm>();

  const scenario = watch("activeScenario");

  return (
    <div className={styles.row}>
      <div className={styles.row_heading}>
        <div className={styles.heading}>
          <span className={styles.title}>Distribute</span>
          <Hint popupText="When this option is selected, installations will occur evenly throughout the day. If this option is not selected, installations are made as quickly as possible." />
        </div>
        <Checkbox
          name="attributes"
          value={NewOrderAttributes.Distribute}
          checked={attributesList.includes(NewOrderAttributes.Distribute)}
          onChange={handleCheckboxChange}
          isDisabled={scenario === NewOrderScenario.extend}
        />
      </div>
      <span
        className={styles.title}
        data-is-disabled={
          !attributesList.includes(NewOrderAttributes.Distribute) ||
          scenario === NewOrderScenario.extend
        }
      >
        Throughout the day
      </span>
    </div>
  );
};
